import { render, staticRenderFns } from "./routeDetail.vue?vue&type=template&id=d5a23b7e&scoped=true&lang=pug&"
import script from "./routeDetail.vue?vue&type=script&lang=js&"
export * from "./routeDetail.vue?vue&type=script&lang=js&"
import style0 from "./routeDetail.vue?vue&type=style&index=0&id=d5a23b7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a23b7e",
  null
  
)

export default component.exports